import { useCallback } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import { Card, Typography } from 'antd';

import { Icon } from '@eduzz/ui-antd-theme';

import { useFileSelector } from '@/hooks/useFileSelector';
import { useUploader } from '@/hooks/useUploader';
import { cn } from '@/lib/cn';

import { UploadItem } from './uploadItem';
import { ErrorMessage } from '../ErrorMessage';

export const Uploader = ({ name }: { name: string }) => {
  const { control } = useFormContext();
  const { append, remove, fields } = useFieldArray({
    control,
    name
  });

  const { selectDeliverables } = useFileSelector();
  const { addFile, uploads, done, abort, retry, isFull } = useUploader({
    onUploadComplete: ({ hash, id, filename, deliverableId, size }) => {
      append({
        hash,
        filename,
        deliverableId,
        id,
        size
      });
    },
    onUploadDelete: (id, filename) => {
      const index = fields.findIndex((f: any) => f.deliverableId === id || f.id === id || f.filename === filename);

      if (index !== -1) {
        remove(index);
      }
    }
  });

  const handleClick = useCallback(async () => {
    try {
      if (isFull) {
        return;
      }

      const files = await selectDeliverables();

      files.forEach(addFile);
    } catch (error) {
      console.error('File selection was cancelled or failed:', error);
    }
  }, [selectDeliverables, addFile, isFull]);

  return (
    <div className='flex flex-col gap-2'>
      {!!uploads.length && (
        <div className='flex flex-col gap-2'>
          {uploads.map(u => (
            <UploadItem key={u.id} upload={u} done={done} abort={abort} retry={retry} />
          ))}
        </div>
      )}

      <Card
        onClick={handleClick}
        id='upload-files-button'
        size='small'
        className={cn(
          'hover:border-primary cursor-pointer flex-row items-center justify-between border border-dashed transition-colors',
          { 'cursor-not-allowed': isFull }
        )}
      >
        <div className='data relative flex flex-row items-center gap-2'>
          <span
            id='upload-files-button-icon'
            aria-hidden
            className='flex size-8 shrink-0 items-center justify-center rounded-full bg-sky-100'
          >
            <Icon.Upload className='text-primary!' />
          </span>

          <div className='flex-1'>
            <Typography.Text className='text-primary mb-0 font-bold'>
              <span className='hidden md:inline'>Clique </span>
              <span className='inline md:hidden'>Toque </span>
              para enviar os arquivos
            </Typography.Text>
            <div className='text-content-subtitle text-sm'>PDF, EPUB, MOBI, DOCX, JPG, PNG, CSV</div>
          </div>
        </div>
      </Card>
      <ErrorMessage fieldName={name} />
    </div>
  );
};
